import { useCallback, useState } from "react";
import { useOasisBackend } from '../hooks/useOasisBackend'
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Input } from '../components/ui/input';

const PasswordReset = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const db = useOasisBackend()
  let { token } = useParams();

  const submitLogin = useCallback(() => {
    if (password !== confirmPassword) {
        toast.error("Passwords do not match");
        return;
    }
    if(!!!token) {
        toast.error("No token provided, incorrect URL");
        return;
    }

    db.endpoints.passwordReset.passwordResetCreate(token, {password, confirm_password: confirmPassword}).then(() => {
        window.location.href = "/"
    }).catch((error) => {
        toast.error(error.response.data.message);
    });

  }, [password, confirmPassword, token]);

  return (
    <div className="min-h-screen bg-pitchDeckBlack flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-pitchDeckBlack/50 border border-pitchDeckTeal rounded-xl p-8 shadow-lg">
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-6 text-center">
            Reset Password
          </h1>
          
          <div className="space-y-4">
            <div>
              <Input 
                type="password" 
                placeholder="New Password" 
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-pitchDeckBlack/50 border-pitchDeckTeal/30 text-white placeholder:text-white/60 focus:border-pitchDeckTeal focus:ring-pitchDeckTeal/20"
              />
            </div>
            
            <div>
              <Input 
                type="password" 
                placeholder="Confirm New Password" 
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full bg-pitchDeckBlack/50 border-pitchDeckTeal/30 text-white placeholder:text-white/60 focus:border-pitchDeckTeal focus:ring-pitchDeckTeal/20"
              />
            </div>
            
            <button 
              onClick={submitLogin}
              className="w-full bg-pitchDeckTeal text-pitchDeckBlack font-bold py-3 px-6 rounded-lg hover:bg-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-pitchDeckTeal/50 focus:ring-offset-2 focus:ring-offset-pitchDeckBlack"
            >
              Reset Password
            </button>
          </div>
          
          <p className="text-white/60 text-sm text-center mt-6">
            Enter your new password to complete the reset process
          </p>
        </div>
      </div>
    </div>
  )
}

export default PasswordReset